export default __webpack_public_path__ + "static/media/old_platinum_card_selected.cdddccd0.png";